/**
 * Feature flags for the new evidence locker workstreams.
 *
 * - `newEvidenceLockerJake` — full new chat stack (`ChatNew` / `QuestionBarNew`).
 * - `oldChatNewEvidenceLocker` — legacy chat + composer with the new locker modal only.
 *
 * Set the matching FORCE_* constant to `true` for local dev without LaunchDarkly.
 */
export const FORCE_NEW_EVIDENCE_LOCKER_JAKE = false;
export const FORCE_OLD_CHAT_NEW_EVIDENCE_LOCKER = false;

export function shouldUseNewEvidenceLockerStack(
  featureFlags: { newEvidenceLockerJake?: unknown } | undefined,
): boolean {
  return FORCE_NEW_EVIDENCE_LOCKER_JAKE || !!featureFlags?.newEvidenceLockerJake;
}

export function shouldUseOldChatNewEvidenceLocker(
  featureFlags: { oldChatNewEvidenceLocker?: unknown } | undefined,
): boolean {
  return (
    FORCE_OLD_CHAT_NEW_EVIDENCE_LOCKER || !!featureFlags?.oldChatNewEvidenceLocker
  );
}
